import React from 'react';
import { capitalize } from 'lodash';

import { QueryStringContext } from 'contexts/QueryStringContext';
import { Dropdown, NavLabel, Row, SubnavButton } from '../styles';

const UNITS_TO_SET = ['k', 'm', 'b'];
const UNITS = ['Thousand', 'Million', 'Billion'];

export class CurrencyUnitsSelect extends React.Component {
	state = {
		open: false,
	};

	handleChangeOpen = open => {
		this.setState({ open });
	};

	handleChange = value => {
		const { setQueryStringStateAndPush } = this.props;
		const unit = UNITS_TO_SET[UNITS.indexOf(value)];
		setQueryStringStateAndPush({ unit });
		this.setState({ open: false });
	};

	render() {
		const { unit } = this.props;
		const { open } = this.state;

		const options = UNITS;
		const convertedUint = UNITS[UNITS_TO_SET.indexOf(unit)];
		const label = convertedUint && <span>{capitalize(convertedUint)}</span>;

		return (
			<Dropdown
				label={label}
				hideOpenLabel
				open={open}
				onChangeOpen={this.handleChangeOpen}
			>
				{options.map(item => (
					<SubnavButton
						key={item}
						title={item}
						onClick={() => this.handleChange(item)}
					>
						<Row>
							<NavLabel active={item === convertedUint}>{item}</NavLabel>
						</Row>
					</SubnavButton>
				))}
			</Dropdown>
		);
	}
}

export default props => (
	<QueryStringContext.Consumer>
		{({ unit, setQueryStringStateAndPush }) => (
			<CurrencyUnitsSelect
				{...props}
				unit={unit}
				setQueryStringStateAndPush={setQueryStringStateAndPush}
			/>
		)}
	</QueryStringContext.Consumer>
);

export const getUnitNameByValue = value => {
	const index = UNITS_TO_SET.indexOf(value);

	return UNITS[index] || '';
};
